import { extendTailwindMerge, twJoin } from 'tailwind-merge';

type AdditionalClassGroupIds = 'style' | 'clip';

const twMerge = extendTailwindMerge<AdditionalClassGroupIds>({
  extend: {
    classGroups: {
      style: [
        'style-h1',
        'style-h2',
        'style-h2-bold',
        'style-h3',
        'style-h4',
        'style-h4-bold',
        'style-h5',
        'style-h5-bold',
        'style-h5-extra-bold',
        'style-body',
        'style-body-small',
        'style-body-small-bold',
        'style-button-label-large',
        'style-button-label',
        'style-extra-small-label',
        'style-input-label',
        'style-link',
        'style-link-small',
      ],
      clip: [
        'clip-right',
        'clip-left',
        'clip-top',
        'clip-bottom',
        'clip-y',
        'clip-x',
      ],
    },
  },
});

// twJoin is exported because the tailwind-merge package is ignored in settings.json
export { twMerge, twJoin };
